import { useMemo } from "react";
import { thumbnail } from "~/lib/images";
import { cx } from "~utils";

import styles from "./article-list.module.css";

/**
 * @param {string} image
 * @returns {{src: string, srcSet: string}}
 */
function gridImageSrc(image) {
  return {
    src: thumbnail(image, { width: 450 }),
    srcSet: null,
    sizes: null,
  };
}

/**
 * @param {string} image
 * @returns {{src: string, srcSet: string}}
 */
function heroSrc(image) {
  const src = thumbnail(image, { width: 615 });
  return {
    src: src,
    srcSet: [
      `${src} 615w`,
      thumbnail(image, { width: 1000 }) + " 980w", // Pixel perfect image for 1x desktops
    ].join(", "),
  };
}

export const Image = ({
  className,
  image,
  imageAltText = "",
  imageBlockSyndication = false,
  lazyload = true,
  layout = "grid",
  ...props
}) => {
  const imageAlt = imageAltText || "Scientific American Logo";

  // Aim to strike a balance between pixel density and asset size
  const { src, srcSet } = useMemo(() => {
    if (layout === "hero") {
      return heroSrc(image);
    }
    return gridImageSrc(image);
  }, [image, layout]);

  let figAttrs = {
    className: cx(styles.articleFigure, className),
    style: {"--ratio": "var(--image-ratio, 56.25%)"},
    ...props
  };

  if (imageBlockSyndication) {
    figAttrs["data-disable-apple-news"] = true;
  }

  return (
    <figure { ...figAttrs }>
      <img
        alt={imageAlt}
        className={styles.articleImg}
        src={src}
        srcSet={srcSet}
        loading={lazyload ? "lazy" : "eager"}
      />
    </figure>
  );
};
